module.exports = __webpack_public_path__ + "img/upcoming-events_cfp-national-champ.ef266b06.jpg";